/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiMemberFieldsDtoAddMemberFieldDto,
  WebApiMemberFieldsDtoMemberUploadFieldDto,
  WebApiMemberFieldsDtoSaveMemberFieldSettingsDto,
  WebApiModelsMemberField,
} from '../models';
import {
    WebApiMemberFieldsDtoAddMemberFieldDtoFromJSON,
    WebApiMemberFieldsDtoAddMemberFieldDtoToJSON,
    WebApiMemberFieldsDtoMemberUploadFieldDtoFromJSON,
    WebApiMemberFieldsDtoMemberUploadFieldDtoToJSON,
    WebApiMemberFieldsDtoSaveMemberFieldSettingsDtoFromJSON,
    WebApiMemberFieldsDtoSaveMemberFieldSettingsDtoToJSON,
    WebApiModelsMemberFieldFromJSON,
    WebApiModelsMemberFieldToJSON,
} from '../models';

export interface ApiMemberFieldAddMemberFieldPostRequest {
    webApiMemberFieldsDtoAddMemberFieldDto?: WebApiMemberFieldsDtoAddMemberFieldDto;
}

export interface ApiMemberFieldSaveMemberFieldsPostRequest {
    webApiMemberFieldsDtoSaveMemberFieldSettingsDto?: WebApiMemberFieldsDtoSaveMemberFieldSettingsDto;
}

/**
 * 
 */
export class MemberFieldApi extends runtime.BaseAPI {

    /**
     * Adds a new member field to the company
     */
    async apiMemberFieldAddMemberFieldPostRaw(requestParameters: ApiMemberFieldAddMemberFieldPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiModelsMemberField>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/AddMemberField`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMemberFieldsDtoAddMemberFieldDtoToJSON(requestParameters.webApiMemberFieldsDtoAddMemberFieldDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiModelsMemberFieldFromJSON(jsonValue));
    }

    /**
     * Adds a new member field to the company
     */
    async apiMemberFieldAddMemberFieldPost(requestParameters: ApiMemberFieldAddMemberFieldPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiModelsMemberField> {
        const response = await this.apiMemberFieldAddMemberFieldPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiMemberFieldCreateMemberUploadTemplatePostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/CreateMemberUploadTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiMemberFieldCreateMemberUploadTemplatePost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMemberFieldCreateMemberUploadTemplatePostRaw(initOverrides);
    }

    /**
     * 
     */
    async apiMemberFieldGetMemberFieldsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsMemberField>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/GetMemberFields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsMemberFieldFromJSON));
    }

    /**
     * 
     */
    async apiMemberFieldGetMemberFieldsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsMemberField>> {
        const response = await this.apiMemberFieldGetMemberFieldsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiMemberFieldGetMemberUploadFieldsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiMemberFieldsDtoMemberUploadFieldDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/GetMemberUploadFields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiMemberFieldsDtoMemberUploadFieldDtoFromJSON));
    }

    /**
     * 
     */
    async apiMemberFieldGetMemberUploadFieldsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiMemberFieldsDtoMemberUploadFieldDto>> {
        const response = await this.apiMemberFieldGetMemberUploadFieldsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiMemberFieldGetUnusuedMemberFieldsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsMemberField>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/GetUnusuedMemberFields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsMemberFieldFromJSON));
    }

    /**
     * 
     */
    async apiMemberFieldGetUnusuedMemberFieldsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsMemberField>> {
        const response = await this.apiMemberFieldGetUnusuedMemberFieldsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiMemberFieldSaveMemberFieldsPostRaw(requestParameters: ApiMemberFieldSaveMemberFieldsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MemberField/SaveMemberFields`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMemberFieldsDtoSaveMemberFieldSettingsDtoToJSON(requestParameters.webApiMemberFieldsDtoSaveMemberFieldSettingsDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiMemberFieldSaveMemberFieldsPost(requestParameters: ApiMemberFieldSaveMemberFieldsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiMemberFieldSaveMemberFieldsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
